import { type Ref, forwardRef } from 'react';

import { TextField, type TextFieldProps } from '@mui/material';
import {
  type CountryCode,
  formatIncompletePhoneNumber,
  getCountryCallingCode,
} from 'libphonenumber-js';
import { useRifm } from 'rifm';

export const getInitialPhonePrefix = (countryCode: null | string): string => {
  return `+${getCountryCallingCode((countryCode as CountryCode) ?? 'CH')}`;
};

type Props = {
  onChange: (value: string) => void;
};

type PhoneInputProps = Omit<TextFieldProps, 'onChange'> & Props;

export const formatPhoneNumber = (str: string): string => {
  const clean = str?.replace(/[^\d]+/gi, '').slice(0, 16);
  const formatted = formatIncompletePhoneNumber(`+${clean}`);
  return formatted;
};

export const getPhoneLabel = (
  phone: string | null | undefined,
  emptyLabel: string,
): string => (phone ? formatPhoneNumber(phone) : emptyLabel);

export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(
  (props, ref: Ref<HTMLInputElement>) => {
    const rifm = useRifm({
      accept: /[\d+]+/g,
      format: formatPhoneNumber,
      value: formatPhoneNumber((props?.value || props.defaultValue) as string),
      onChange: v => props?.onChange(v === '+' ? '' : v),
    });

    return (
      <TextField
        {...props}
        ref={ref}
        type="tel"
        autoComplete="tel"
        onBlur={props.onBlur}
        value={rifm.value}
        onChange={rifm.onChange}
      />
    );
  },
);
